import {
    FocusBoxWrap,
    FocusImageLink,
    FocusImage,
    FocusTitle,
    FocusDesc,
    NewsNewBox,
    SrollPane,
    NewsNewItem,
    NewsNewLink,
    CommentTotal,
    CommentLabel,
    CommentIcon,
    NewsNewTitleName,
    FlexLayout,
    ListNewsFocus,
    NewsFocusItem,
    NewsFocusImageLink,
    NewsFocusImage,
    NewsFocusTitle,
} from './focusBoxElements'
import ReactHtmlParser from 'react-html-parser'
import Grid from '@material-ui/core/Grid';
import newsApi from '../../api/newsApi'
import { useEffect, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const FocusBox = () => {
    const [news, setNews] = useState({})
    const [loading, setLoading] = useState(true)
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const getNews = async () => {
            const response = await newsApi.getNewsFocus()
            setNews(response.news)
            setLoading(false)
        }

        getNews()
    },[])

    if(loading) return <></>
    return (
        <>
            <FlexLayout>
                <FocusBoxWrap>
                    <FocusImageLink title={news[0].title} to={`/news/${news[0]._id}`}>
                        <FocusImage src={news[0].image} alt={news[0].title} />
                    </FocusImageLink>
                    <FocusTitle title={news[0].title} to={`/news/${news[0]._id}`}>{news[0].title}</FocusTitle>
                    <FocusDesc>{ReactHtmlParser(news[0].description)}</FocusDesc>
                </FocusBoxWrap>
                <NewsNewBox className='hide-on-mobile'>
                    <SrollPane>
                        {news.slice(1, 11).map((news, index) => (
                            <NewsNewItem key={news._id}>
                                <NewsNewTitleName>
                                    <NewsNewLink title={news.title} to={`/news/${news._id}`}>{news.title}</NewsNewLink>
                                    {news.comments.length > 0 &&
                                        <CommentTotal>
                                            <CommentLabel>{news.comments.length}</CommentLabel>
                                            <CommentIcon/>
                                        </CommentTotal>
                                    }
                                </NewsNewTitleName>
                            </NewsNewItem>
                        ))}
                    </SrollPane>
                </NewsNewBox>
            </FlexLayout>
            <ListNewsFocus>
                <Grid container spacing={isSmall ? 0 : 2} >
                        {news.slice(11, 15).map((news, index) => (
                            <Grid key={news._id} item xs={12} sm={3} >
                                <NewsFocusItem>
                                    <NewsFocusImageLink to={`/news/${news._id}`} title={news.title}>
                                        <NewsFocusImage src={news.image} alt={news.name} />
                                    </NewsFocusImageLink>
                                    <NewsFocusTitle to={`/news/${news._id}`} title={news.title}>{news.title}</NewsFocusTitle>
                                </NewsFocusItem>
                            </Grid>
                        ))}
                </Grid>
            </ListNewsFocus>
        </>
    )
}

export default FocusBox
